var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['new-tab-tag', _vm.forceBol ? 'force-bol' : ''],style:([_vm.cssProps,_vm.cssStyle])},[_c('span',{staticClass:"new-tag-content"},[_vm._v("Nova")])])}
var staticRenderFns = []

export { render, staticRenderFns }